import React from 'react';
import { LenderMatchDrillIn } from '../../shared/models';
import { PlatformRootUrl } from '../../shared/utils/platform';
import { Button, ButtonGroup, ClickAwayListener, Grow, MenuItem, MenuList, Paper, Popper } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

interface LenderMatchRowActionButtonProps {
	lender: LenderMatchDrillIn;
	summaryActive: boolean;
	toggleSummary: (toggle: boolean) => void;
}

type LenderMatchRowActionItem = keyof typeof LenderMatchRowActionItemMap;
const LenderMatchRowActionItemMap = {
	DealCriteria: 'Deal Criteria',
	LenderScoreSummary: 'Lender Score Summary',
	LenderScoreDetails: 'Lender Score Details',
};

export const LenderMatchRowActionButton: React.FC<LenderMatchRowActionButtonProps> = ({
	lender,
	summaryActive,
	toggleSummary,
}) => {
	const [open, setOpen] = React.useState(false);
	const anchorRef = React.useRef<HTMLDivElement>(null);

	const handleToggle = () => {
		setOpen(prevOpen => !prevOpen);
	};

	const openCriteria = (lender: LenderMatchDrillIn) => {
		window.open(`${PlatformRootUrl}/BankDealProfiles/UnderwritingCriteria/${lender.bankContactGuid}`, '_blank');
	};

	const openScoreDetails = (lender: LenderMatchDrillIn) => {
		window.open(`${PlatformRootUrl}/Emp/LenderScoreDetails/${lender.bankContactGuid}`, '_blank');
	};

	const handleClick = (action: LenderMatchRowActionItem) => {
		switch (action) {
			case 'DealCriteria':
				openCriteria(lender);
				break;
			case 'LenderScoreSummary':
				toggleSummary(!summaryActive);
				break;
			case 'LenderScoreDetails':
				openScoreDetails(lender);
				break;
		}
	};

	const handleClose = (event: Event) => {
		if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
			return;
		}

		setOpen(false);
	};

	const handleMenuItemClick = (
		event: React.MouseEvent<HTMLLIElement, MouseEvent>,
		actionItem: LenderMatchRowActionItem
	) => {
		setOpen(false);
		handleClick(actionItem);
	};

	return (
		<>
			<ButtonGroup variant="contained" ref={anchorRef} aria-label="split button">
				<Button onClick={handleToggle}>Actions</Button>
				<Button
					size="small"
					aria-controls={open ? 'split-button-menu' : undefined}
					aria-expanded={open ? 'true' : undefined}
					aria-label="select merge strategy"
					aria-haspopup="menu"
					onClick={handleToggle}
				>
					<ArrowDropDownIcon />
				</Button>
			</ButtonGroup>
			<Popper
				open={open}
				style={{ zIndex: 1000, margin: 0 }}
				anchorEl={anchorRef.current}
				role={undefined}
				transition
				disablePortal
			>
				{({ TransitionProps, placement }) => (
					<Grow
						{...TransitionProps}
						style={{
							transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
						}}
					>
						<Paper>
							<ClickAwayListener onClickAway={handleClose}>
								<MenuList id="split-button-menu">
									<MenuItem onClick={event => handleMenuItemClick(event, 'DealCriteria')}>
										{LenderMatchRowActionItemMap['DealCriteria']}
									</MenuItem>
									<MenuItem onClick={event => handleMenuItemClick(event, 'LenderScoreSummary')}>
										{LenderMatchRowActionItemMap['LenderScoreSummary']}
									</MenuItem>
									<MenuItem onClick={event => handleMenuItemClick(event, 'LenderScoreDetails')}>
										{LenderMatchRowActionItemMap['LenderScoreDetails']}
									</MenuItem>
								</MenuList>
							</ClickAwayListener>
						</Paper>
					</Grow>
				)}
			</Popper>
		</>
	);
};
